

<dashboardnav>
  <!-- <mrsoftapps-GenericReference>
  </mrsoftapps-GenericReference> -->

    <!-- <pre>{{stakeholdergroups$ | async | json}}</pre> -->

  <mrsoftapps-GenericReference  [stakeholderreferences]="stakeholderrefData$ | async" [countries] = "countries$ | async" [stakeholdergroups] = "stakeholdergroups$ | async"  [selectedReferenceType]="selectedReferenceType"  [selectedCountryId]="selectedCountryId" [selectedStakeholderGroupId]="selectedStakeholderGroupId"
  *ngIf="!(isLoadingStakeholderReference$ | async)"  (selectedRefType)='selectedValueChange($event)' (selectedCountry)='selectedCountryChange($event)' (selectedStakeholderGroup)='selectedStakeholderGroupChange($event)'
  
  (changeEmit)="onSubmitStakeholderReference($event)"
  (deleteEvent)="onDelete($event)"
  >
  
  </mrsoftapps-GenericReference>

  <div >
  <!-- <pre>{{stakeholderrefData$ | async | json}}</pre> -->

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingStakeholderReference$ | async)">
  </mrsoftapps-epims-reference-spinner>

  </div>

  

  
</dashboardnav>

